<template>
  <div>
    <Layout :containers="containers">
      <template v-slot:header>
        <DefaultHeroBar
          :hasQuickStartCallout="false"
          :heroTitle="'Plan ahead: Calculate your estate administration costs'"
          :heroDescription="'Use our free calculator to plan for estate administration fees and protect your loved ones.'"
          :section="'calculator'"
        />
      </template>
      <template v-slot:calculator>
        <Breadcrumb />
        <EstateAdministrationCostCalculator
          @signup="signup"
          @success="showSuccessMessage"
        />
      </template>
    </Layout>
    <SuccessSnackbar v-model="showSuccess" :message="successMessage" />
    <SuccessSnackbar v-model="showAlert" :message="alertMessage" />
    <ErrorSnackbar v-model="showError" />
  </div>
</template>
<script>
import Layout from "../../common/layouts/Layout.vue";
import EstateAdministrationCostCalculator from "./EstateAdministrationCostCalculator.vue";
import DefaultHeroBar from "../../common/DefaultHeroBar.vue";
import DynamicNavDrawer from "../DynamicNavDrawer.vue";
import DrawerSignUp from "../DrawerSignUp.vue";
import DrawerSignIn from "../DrawerSignIn.vue";
import Breadcrumb from "../../common/Breadcrumb.vue";
import SuccessSnackbar from "../../common/SuccessSnackbar.vue";
import ErrorSnackbar from "../../common/ErrorSnackbar.vue";
export default {
  name: "EstateAdministrationCostCalculatorContainer",
  components: {
    EstateAdministrationCostCalculator,
    DefaultHeroBar,
    Layout,
    DynamicNavDrawer,
    DrawerSignUp,
    DrawerSignIn,
    Breadcrumb,
    SuccessSnackbar,
    ErrorSnackbar,
  },
  metaInfo() {
    return {
      title: this.whitelabel.metaData.calculator.title,
      meta: [
        {
          name: "description",
          content: this.whitelabel.metaData.calculator.description,
        },
        {
          property: "og:title",
          content: this.whitelabel.metaData.calculator.ogTitle,
        },
        {
          property: "og:image",
          content: this.whitelabel.metaData.calculator.ogImage,
        },
        {
          property: "og:type",
          content: this.whitelabel.metaData.calculator.ogType,
        },
        {
          property: "og:url",
          content: this.whitelabel.metaData.calculator.ogUrl,
        },
        {
          property: "og:description",
          content: this.whitelabel.metaData.calculator.description,
        },
        {
          property: "og:site_name",
          content: this.whitelabel.metaData.calculator.ogSiteName,
        },
      ],
    };
  },
  data() {
    return {
      signUpDrawerOpen: false,
      signInDrawerOpen: false,
      successMessage: null,
      errorMessage: null,
      showSuccess: false,
      showError: false,
      showAlert: false,
      alertMessage: null,
    };
  },
  computed: {
    containers() {
      return [
        {
          name: "header",
          background: "countryPattern",
          class: "hero-banner",
        },
        {
          name: "calculator",
          background: "countryPattern",
          accents: ["green-accent-1"],
          fadedRow: true,
          class: "calculator",
        },
      ];
    },
  },
  methods: {
    successResetPassword() {
      this.signInDrawerOpen = false;
      this.alertMessage =
        this.whitelabel.authentication.resetPassword.successMessage;
      this.showAlert = true;
    },
    signup() {
      this.$router.push("/register");
    },
    drawerClosed() {
      this.signUpDrawerOpen = false;
    },
    loginClicked() {
      this.signUpDrawerOpen = false;
      this.signInDrawerOpen = true;
    },
    signInDrawerClosed() {
      this.signInDrawerOpen = false;
    },
    showSuccessMessage(success) {
      if (success) {
        this.successMessage = "Thank you. An advisor will contact you.";
        this.showSuccess = true;
      } else {
        this.showError = true;
      }
    },
  },
};
</script>
